<template>
  <v-combobox
    :value="value"
    @update:search-input="$emit('input', $event)"
    @input="$emit('input', $event)"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    label="Názov firmy"
    hide-details
    dense
    clearable
  ></v-combobox>
</template>

<script>
import {
  useCompanyNamesListQuery,
  useCompanyPilverNamesListQuery,
} from "@/graphql/listQueries";
import { useResult } from "@vue/apollo-composable";
import { ref, watch } from "vue-demi";

export default {
  props: {
    value: { type: String },
    default: {
      type: [Object, String],
      default: null,
    },
    type: { type: String },
  },
  setup(props, { emit }) {
    const search = ref(null);
    let searchTimer = null;
    const { result, loading, refetch } =
      props.type === "Pilver"
        ? useCompanyPilverNamesListQuery({
            paging: { limit: 20, offset: 0 },
          })
        : useCompanyNamesListQuery({
            paging: { limit: 20, offset: 0 },
          });

    const items =
      props.type === "Pilver"
        ? useResult(result, [], (r) =>
            r.companyPilvers.nodes
              ? r.companyPilvers.nodes.map((n) => n.Name)
              : []
          )
        : useResult(result, [], (r) =>
            r.companies.nodes ? r.companies.nodes.map((n) => n.Name) : []
          );

    watch(
      () => props.default,
      () => {
        if (props.default && props.default.Id !== props.value) {
          items.value.push(props.default);
          emit("input", props.default.Id);
        }
      }
    );

    watch(search, (val) => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        refetch({
          paging: { limit: 20, offset: 0 },
          filter: val ? { Name: { iLike: `%${val}%` } } : undefined,
        });
      }, 250);
    });

    return { search, items, loading };
  },
};
</script>
<style></style>
